export function getMobileBottomSheetPaperRow() {
  return {
    top: 'calc(var(--vv-offset-top, 0px) + env(safe-area-inset-top, 0px)) !important',
    bottom: 'auto !important',
    left: '0 !important',
    right: '0 !important',
    width: '100% !important',
    maxWidth: '100% !important',
    height:
      'calc(var(--vv-height, 100dvh) - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)) !important',
    maxHeight:
      'calc(var(--vv-height, 100dvh) - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)) !important',
  };
}
